import classNames from 'classnames';
import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_ACCOMMODATION } from 'shared/constants/common';
import AccommodationItem from './AccommodationItem';

export default function Accommodation({ accommodationList = [] }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_ACCOMMODATION}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionTitle label="Accommodation" className="ml-2 mt-1" />
      </div>
      {accommodationList.map((accommodation, index) => (
        <div
          key={`${index + 1}`}
          className={classNames({ 'mt-10': index !== 0 })}
        >
          <AccommodationItem accommodation={accommodation} />
        </div>
      ))}
    </>
  );
}
